import { deliveryFeeAPI } from '../api';

type Coords = { latitude: number; longitude: number };

const locationCache = new Map<number, Promise<Coords | null>>();

function parseCoords(lat: unknown, lon: unknown): Coords | null {
  const a = typeof lat === 'number' ? lat : parseFloat(String(lat ?? ''));
  const b = typeof lon === 'number' ? lon : parseFloat(String(lon ?? ''));
  if (!Number.isFinite(a) || !Number.isFinite(b)) return null;
  if (Math.abs(a) < 0.0001 && Math.abs(b) < 0.0001) return null;
  if (a < -90 || a > 90 || b < -180 || b > 180) return null;
  return { latitude: a, longitude: b };
}

/** Warm / reuse listing seller coordinates (avoids a second wait on every map mount). */
export function prefetchListingMapLocation(listingId: number): Promise<Coords | null> {
  if (!Number.isFinite(listingId) || listingId <= 0) return Promise.resolve(null);
  const existing = locationCache.get(listingId);
  if (existing) return existing;

  const promise = deliveryFeeAPI
    .getListingLocation(listingId)
    .then((loc) => parseCoords(loc?.latitude, loc?.longitude))
    .catch(() => null);

  locationCache.set(listingId, promise);
  return promise;
}

export function seedListingMapLocation(
  listingId: number,
  latitude: unknown,
  longitude: unknown
): Coords | null {
  const coords = parseCoords(latitude, longitude);
  if (coords) {
    locationCache.set(listingId, Promise.resolve(coords));
  }
  return coords;
}

export async function resolveListingMapLocation(
  listingId: number,
  latitude?: unknown,
  longitude?: unknown
): Promise<Coords | null> {
  const seeded = seedListingMapLocation(listingId, latitude, longitude);
  if (seeded) return seeded;
  return prefetchListingMapLocation(listingId);
}
